import React from "react";
import styled from "styled-components";
import Typography from "../typography";
import { Colors } from "../../utils/colors";

interface IProps {
  check: string;
  status?: string; //default //pass //error
}
const PasswordCheck = ({ check, status = "default" }: IProps) => {
  return (
    <Container status={status}>
      <Typography
        color={
          status === "pass"
            ? Colors.grey700
            : status === "error"
            ? Colors.danger
            : Colors.grey500
        }
      >
        {check}
      </Typography>
      <CheckIcon status={status}>
        {status !== "error" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              fill="currentColor"
              d="M16.03 10.03a.75.75 0 1 0-1.06-1.06l-4.47 4.47l-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0z"
            />
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75S22.75 17.937 22.75 12S17.937 1.25 12 1.25M2.75 12a9.25 9.25 0 1 1 18.5 0a9.25 9.25 0 0 1-18.5 0"
              clip-rule="evenodd"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
          >
            <g fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="12" r="10" />
              <path stroke-linecap="round" d="m14.5 9.5l-5 5m0-5l5 5" />
            </g>
          </svg>
        )}
      </CheckIcon>
    </Container>
  );
};

export default PasswordCheck;

const Container = styled.div<{ status: string }>`
  width: fit-content;
  padding: 0.3rem 0.6rem;
  border-radius: 1rem;
  display: flex;
  margin-right: 0.6rem;
  margin-bottom: 0.2rem;

  transition: all 0.2s ease-in-out;
  color: ${Colors.grey500};
  background-color: ${(props) =>
    props.status === "pass"
      ? "#FEC667"
      : props.status === "error"
      ? Colors.dangerFade
      : ""};
  border: 1px solid
    ${(props) =>
      props.status === "pass"
        ? "#FEC667"
        : props.status === "error"
        ? Colors.danger
        : Colors.grey500};
`;

const CheckIcon = styled.div<{ status: string }>`
  width: 1.6rem;
  margin-left: 0.5rem;
  color: ${(props) =>
    props.status === "pass"
      ? Colors.grey700
      : props.status === "error"
      ? Colors.danger
      : Colors.grey500};
`;
